var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-nav__wrapper", on: { mouseleave: _vm.closeMenu } },
    [
      _c("nav", { staticClass: "main-nav__bar" }, [
        _c(
          "ul",
          { staticClass: "main-nav__list" },
          _vm._l(_vm.catData, function(cat) {
            return _c(
              "li",
              {
                key: cat.id,
                staticClass: "main-nav__item",
                on: {
                  mouseenter: function($event) {
                    return _vm.setActiveCat(cat.id)
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "main-nav__link",
                    class: {
                      "main-nav__link--active": cat.id === _vm.activeCatId
                    },
                    attrs: { href: _vm.buildUrl(cat) }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(cat.details[0].name))]),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "11",
                          height: "6",
                          viewBox: "0 0 11 6"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "#018FB8",
                            "fill-rule": "evenodd",
                            d:
                              "M117.788385,8.20160227 C117.637847,8.06719861 117.464152,8 117.267295,8 C117.070438,8 116.896743,8.06719861 116.746204,8.20160227 L112.820655,12.0152441 L108.895106,8.20160227 C108.744568,8.06719861 108.570873,8 108.374015,8 C108.177158,8 108.003463,8.06719861 107.852925,8.20160227 C107.702387,8.34720319 107.627119,8.51520293 107.627119,8.70560579 C107.627119,8.8960108 107.702387,9.06401054 107.852925,9.20961361 L112.299564,13.5104609 C112.380624,13.5888622 112.470367,13.6448623 112.568795,13.6784628 C112.667224,13.7120633 112.751176,13.7288634 112.820655,13.7288634 C112.890134,13.7288634 112.974086,13.7120633 113.072515,13.6784628 C113.170944,13.6448623 113.260686,13.5888622 113.341746,13.5104609 L117.788385,9.20961361 C117.938924,9.06401054 118.01419,8.8960108 118.01419,8.70560579 C118.01419,8.51520293 117.938924,8.34720319 117.788385,8.20160227 Z",
                            transform: "translate(-107 -8)"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm.isOpen && _vm.activeCat
        ? _c("div", { staticClass: "megamenu" }, [
            _c(
              "div",
              {
                staticClass: "megamenu__container",
                on: { mouseleave: _vm.closeMenu }
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-9" }, [
                    _c(
                      "p",
                      { staticClass: "megamenu__title" },
                      [
                        _c("span", { staticClass: "megamenu__title-main" }, [
                          _vm._v(_vm._s(_vm.activeCat.details[0].name))
                        ]),
                        _vm._v(" "),
                        _vm.activeCat.details[0].shortDescription
                          ? [
                              _c(
                                "span",
                                { staticClass: "megamenu__title-separator" },
                                [_vm._v("-")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "megamenu__title-sub" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.activeCat.details[0].shortDescription
                                    )
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "megamenu__row-container" }, [
                      typeof _vm.activeCat.children != "undefined"
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            _vm._l(_vm.activeCat.children, function(l2Child) {
                              return _c(
                                "div",
                                {
                                  staticClass: "megamenu__l2-block",
                                  on: {
                                    mouseenter: function($event) {
                                      return _vm.setHoveredChildId(l2Child.id)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "megamenu__l2-hl",
                                      attrs: {
                                        href: _vm.buildUrl(
                                          _vm.activeCat,
                                          l2Child
                                        )
                                      }
                                    },
                                    [_vm._v(_vm._s(l2Child.details[0].name))]
                                  ),
                                  _vm._v(" "),
                                  l2Child.details[0].shortDescription
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "megamenu__l2-subtitle"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              l2Child.details[0]
                                                .shortDescription
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  typeof l2Child.children != "undefined"
                                    ? _c(
                                        "ul",
                                        { staticClass: "megamenu__child-list" },
                                        _vm._l(l2Child.children, function(
                                          l3Child
                                        ) {
                                          return _c("li", [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "megamenu__l3-link",
                                                attrs: {
                                                  href: _vm.buildUrl(
                                                    _vm.activeCat,
                                                    l2Child,
                                                    l3Child
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(
                                                      l3Child.details[0].name
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ]
                                            )
                                          ])
                                        }),
                                        0
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-3 megamenu__img-col" }, [
                    _c(
                      "div",
                      { staticClass: "megamenu__image-container" },
                      [
                        _c("transition", [
                          _c("img", {
                            key: _vm.hoveredChildId,
                            staticClass: "megamenu__image",
                            attrs: {
                              src: _vm.hoveredImageURL,
                              alt: _vm.hoveredCatName
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "h4",
                          { key: _vm.hoveredCatName, staticClass: "skew-link" },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.hoveredCatName) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }